// The one honesty rule for a flag the case assessment WITHHELD (contextual
// flag assessment §4.8). Every display surface resolves through this file:
// the table row's chip, the transfer-partner leg and the single-row branch
// (TransactionViewer.js), the transaction detail dialog
// (TransactionDetailDialog.js), and the export text
// (utils/flagExportLabel.js). Same flag, same state, one story.
//
// A flag the case flag assessment withheld — the :SUPPRESSED edge with no
// human verdict on top of it — reads MUTED, not red: "it would have been
// flagged, and it does not apply". A RESTORED flag is a reviewer's human
// verdict undoing the withhold and stays RED even beside its surviving
// audit edge (a restore never deletes the :SUPPRESSED edge — flag.py), or
// the surface lies about who decided. An ordinary live flag (AI PROPOSED,
// human CONFIRMED, or no flag_status at all) is RED everywhere.
//
// The `!flag_restored` half is defensive: the enriched read shadows a
// restored flag's suppressed twin server-side (live wins), so a SUPPRESSED
// row never actually carries the pairing. The display rule keeps the guard
// anyway — a human verdict outranks any audit-edge state — and the pairing
// is pinned by name (TransactionViewerFlagAssessment.test.js, the
// "suppressed flag that was ALSO restored" case): remove the half and
// that case goes muted.
//
// Deliberately NOT here: the row-contract derives (deriveIsWithheldFlag /
// deriveIsRestoredFlag, api/transactions.js:88-106) answer "is this row's
// flag edge the :SUPPRESSED one" for the filter panel and the restore/undo
// optimistic patches, on the bare flag_status. The two families agree on
// every row the read can emit — that is what the shadowing guarantees —
// and only this file owns the presentation rule.
//
// Row shape: works on the raw enriched row, on mapTransactionToFilterable
// Transaction output (flag_status / flag_restored ride the
// `...transaction` spread — P1-5 row contract, api/transactions.js), and
// on the detail item built by mapTransactionToDetailItem (it carries the
// two fields explicitly — that mapper is a deliberate whitelist). Partner
// rows carry no flag_status today — the enriched read keeps t2/rf2
// live-only (transaction.py) — so the rule simply evaluates to red there;
// it holds the moment a partner status ever crosses the boundary.
//
// The neutral treatment is not a colour picked here: color="default" is
// MUI's own neutral pill (8% black wash, label palette.text.primary), and
// the theme maps that label to the design-system gray scale (muiTheme.js
// palette.text ← colors.gray). Measured (agent_code/scratch/
// flag_chip_contrast.py): label on the pill over the row's surfaces =
// 14.86:1 (white) to 12.29:1 (darkest tint) — WCAG AA with margin. The
// WarningIcon stays at every render site; only the colour moves, so the
// shape still reads as a flag.

export const isFlagWithheld = (row) =>
  row?.flag_status === 'SUPPRESSED' && !row?.flag_restored;

// The MUI Chip `color` value for a flagged row's chip: 'default' (muted)
// for a withheld flag, 'error' (red) for every other state.
export const flagChipColor = (row) => (isFlagWithheld(row) ? 'default' : 'error');
